import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-resultado',
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.scss']
})
export class ResultadoComponent implements OnInit {
  @Input() id_premio:number;
  @Output() public home: EventEmitter<any> = new EventEmitter;
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.home.emit(true)
    }, 10000);
  }

  goToHome(){
    this.home.emit(true)
  }

}
